import { DateTimePicker, DateTimePickerField } from "../../../core/components/dateTimePicker.js";
import { ComponentHelper } from "../../../core/util/componentHelper.js"
import React from "react";
export class TimeSpanFilter extends React.Component<TimeSpanFilterProps, any>{
    private _componentFactory = ComponentHelper.createFactory();

    private _dateTimeChanged = (field: DateTimePickerField, value: Date) => {
        this.props.dateTimeChanged(field, value);
    }

    render() {
        let dateTimeProps1 = this._componentFactory.getDefaultDateTimePickerProps();
        dateTimeProps1.field.model = this.props.modelDP1;
        dateTimeProps1.value = this.props.startDate;
        dateTimeProps1.onChange = this._dateTimeChanged;
        let dateTimeProps2 = this._componentFactory.getDefaultDateTimePickerProps();
        dateTimeProps2.field.model = this.props.modelDP2;
        dateTimeProps2.value = this.props.endDate;
        dateTimeProps2.onChange = this._dateTimeChanged;
        return (<div>
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ minWidth: "auto", width: "15%", marginTop: "5px" }}><label>{this.props.nameDP1}</label></div><div style={{ flexGrow: 1 }}><DateTimePicker {...dateTimeProps1} /></div>
            </div>
            {this.props.modelDP2 != null ? <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ minWidth: "auto", width: "15%", marginTop: "5px" }}><label>{this.props.nameDP2}</label></div><div style={{ flexGrow: 1 }}><DateTimePicker {...dateTimeProps2} /></div>
            </div> : null}
        </div>);
    }
}

interface TimeSpanFilterProps {
    dateTimeChanged(field: DateTimePickerField, value: any): void;
    startDate: Date;
    endDate?: Date;
    modelDP1: string;
    modelDP2?: string;
    nameDP1: string;
    nameDP2?: string;
}